import React from 'react';
import { Form } from 'react-final-form';

import FormField from 'components/Form/FormField';
import {
  required,
  composeValidators,
  mustBeNumber,
} from 'utils/formValidators';
import 'assets/scss/soonoGetStarted.css';

const ConfirmChargeForm = ({
  chargeDetails,
  businessName,
  onCancel,
  handleNext,
}) => {
  const { amount, description } = chargeDetails;

  return (
    <Form
      onSubmit={handleNext}
      render={({ handleSubmit, form, submitting }) => (
        <form className="form mt-4 mb-5 text-left text-dark soono-transaction-form px-4">
          <div className="row">
            <p className="font-weight-bold text-center">
              Are you sure you want to charge {businessName} ${amount}?
            </p>
          </div>
          <div className="text-center">
            <p>The charge will appear with the following description:</p>
            <p>{`"${description}"`}</p>
          </div>
          <div className="form-group mt-4 d-flex justify-content-center align-items-baseline">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="btn btn-sm px-4 mr-2 border-0 bg-transparent text-center mt-4"
            >
              Cancel
            </button>
            <button
              className="btn-warning px-5 py-2 text-white border-0"
              type="submit"
              onClick={handleSubmit}
            >
              Proceed
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default ConfirmChargeForm;



// WEBPACK FOOTER //
// ./src/components/Form/payment/confirmCharge.js